<app-header />
<main>
  <app-side-nav />
</main>
<app-footer />